import { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import Input from "../../../../ui/molecules/input"
import { CustomRadio } from "../../../../ui/molecules/radioButton"
import { GGNotificationLotCreation, resetLotCreationRequest, setLotCreationAddress, setLotCreationDestinationCountry, setLotCreationGGnotificationCOCTabId, setLotCreationLabelling, setLotCreationManipulationPeriod, setLotCreationProducts, setLotCreationTotalQuantity } from "./slice"
import Button from "../../../../ui/molecules/button"

interface Props {
    close: () => void
}

export function CoCPopup(props: Props) {
    const dispatch = useAppDispatch()
    const ggNotificationCoCState = useAppSelector(state => state.ggNotificationCoC)
    const [labelling, setLabelling] = useState<string | null>(null)

    useEffect(() => {
        dispatch(setLotCreationGGnotificationCOCTabId(ggNotificationCoCState.tabIdToUpdate))
    }, [])

    useEffect(() => {
            if(ggNotificationCoCState.lotCreationStatus === 'successfully') {
                dispatch(resetLotCreationRequest())
                props.close()
            }
    }, [ggNotificationCoCState.lotCreationStatus])

    return (
        <div>
            <div className="bg-brandPrimary-100 pr-5 pl-5 pt-4 pb-5" style={{ borderTopWidth: 1 }}>
                <div className="pb-3" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <div style={{ flex: '0.5' }}>
                        <Input
                            label={'Sito - Indirizzo'}
                            placeholder="Specifica sito (indirizzo)..."
                            value={ggNotificationCoCState.lotCreationRequest.address}
                            onChangeText={(text) => dispatch(setLotCreationAddress(text))}
                        />
                    </div>
                    <div style={{ flex: '0.5' }}>
                        <Input
                            label={'Prodotti'}
                            placeholder="Specifica prodotti..."
                            value={ggNotificationCoCState.lotCreationRequest.products}
                            onChangeText={(text) => dispatch(setLotCreationProducts(text))}
                        />
                    </div>
                </div>

                <div className="pb-3" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <div style={{ flex: '0.5' }}>
                        <Input
                            label={'Quantitativi totali previsti'}
                            placeholder="Specifica quantitativi..."
                            value={ggNotificationCoCState.lotCreationRequest.totalQuantity}
                            onChangeText={(text) => dispatch(setLotCreationTotalQuantity(Number(text)))}
                        />
                    </div>
                    <div style={{ flex: '0.5' }}>
                        <Input
                            label={"Periodo Manipolazione del prodotto o periodo di presenza presso l'azienda"}
                            placeholder="Specifica periodo..."
                            value={ggNotificationCoCState.lotCreationRequest.manipulationPeriod}
                            onChangeText={(text) => dispatch(setLotCreationManipulationPeriod(text))}
                        />
                    </div>
                </div>

                <div className="mb-5" style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                    <span className='notify-text-bold'>
                        Etichettatura
                    </span>
                    <div style={{ display: 'flex' }}>
                        <CustomRadio
                            options={[{ label: '', value: '1' }]}
                            selectedValue={labelling}
                            onChange={(value) => {
                                setLabelling(value)
                                dispatch(setLotCreationLabelling(true))
                            }}
                            id={'crop1'}
                            name={'crop1'}
                        />
                        <div className='text-left'>
                            <span className='subtitle' style={{ color: '#5a8388' }}>Sì</span>
                        </div>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <CustomRadio
                            options={[{ label: '', value: '2' }]}
                            selectedValue={labelling}
                            onChange={(value) => {
                                setLabelling(value)
                                dispatch(setLotCreationLabelling(false))
                            }}
                            id={'crop2'}
                            name={'crop2'}
                        />
                        <div className='text-left'>
                            <span className='subtitle' style={{ color: '#5a8388' }}>No</span>
                        </div>
                    </div>
                </div>

                <div className="pb-3">
                    <Input
                        label={"Paese destinazione"}
                        placeholder="Specifica paese..."
                        value={ggNotificationCoCState.lotCreationRequest.destinationCountry}
                        onChangeText={(text) => dispatch(setLotCreationDestinationCountry(text))}
                    />
                </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', padding: 15, paddingRight: 15 }}>
                <Button
                    size="md"
                    variant="outline"
                    iconPosition="off"
                    label="Annulla"
                    color="dimgrey"
                    onClick={() => {
                        dispatch(resetLotCreationRequest())
                        props.close();
                    }}
                />
                <div className="pl-2">
                    <Button
                        size="md"
                        variant="solid"
                        iconPosition="off"
                        label="Salva"
                        color="orange"
                        onClick={() => dispatch(GGNotificationLotCreation(ggNotificationCoCState.lotCreationRequest))}
                    />
                </div>
            </div>
        </div>
    )
}